// Register.js - ফিক্সড ও রি-ডিজাইন করা ভার্সন
import {Picker} from '@react-native-picker/picker';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import axios from 'axios';
import * as Network from 'expo-network';
import {Formik} from 'formik';
import React, {useContext, useEffect, useState} from 'react';
import {
  Platform,
  Dimensions,
  Image,
  TouchableOpacity,
  Keyboard,
  Modal,
  ScrollView,
  StyleSheet,
  TextInput,
  Button,
  Text,
  TouchableHighlight,
  TouchableWithoutFeedback,
  KeyboardAvoidingView,
  View,
} from 'react-native';
import * as yup from 'yup';
import {BASE_URL} from '../../components/BaseUrl';
import AppBtn from '../../shared/appBtn';
import Checkbox from '../../shared/checkboxC';
import ContainerFluid from '../../shared/containerFluid';
import ErrorMessage from '../../shared/errorMessage';
import ErrorText from '../../shared/errorText';
import FormGroup from '../../shared/formGroup';

import Input from '../../shared/input';
import InputLevel from '../../shared/inputLevel';
import {globalStyles} from '../../styles/globalStyles';
import {serializeErrors} from '../../utils/Helpers';
import useErrorHandler from '../../utils/custom-hooks/ErrorHandler';

import DateTimePickerModal from 'react-native-modal-datetime-picker';
import moment from 'moment';
import {Popable} from 'react-native-popable';

import {
  DatePickerModal,
  DatePickerModalContent,
  TimePickerModal,
  DatePickerInput,
} from 'react-native-paper-dates';
import Icon from 'react-native-vector-icons/MaterialIcons';

const windowWidth = Dimensions.get('window').width;

//register validation schema
const registerSchema = yup.object({
  UserName: yup.string().required('User Name is required'),
  name: yup.string(),
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter valid email'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be minimum of 6 charaters'),
  confirmPassword: yup
    .string()
    .required('Confimation Password is required')
    .oneOf([yup.ref('password'), null], "Passwords don't match"),
  mobile: yup
    .string()
    .matches(/(01)(\d){9}\b/, 'Enter a valid phone number')
    .required('Mobile number is required'),
  member_id: yup.string().required('Member Id is required'),
});

const otpSchema = yup.object({
  OtpKey: yup
    .string()
    .required('Otp is required')
    .length(4, 'Otp must be  4 charaters'),
});

function Register() {
  const {error, showError} = useErrorHandler(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigation = useNavigation();
  const [modalVisible, setModalVisible] = useState(false);
  const [userId, setUser_id] = useState(false);
  const [DId, setDevice_id] = useState(null);
  const [DInfo, setDevice_info] = useState(null);

  const [division, setdivision] = useState([]);
  const [district, setDistrict] = useState([]);
  const [select_date, setselectdate] = useState(null);
  const [isDatePickerVisible, setDatePickerVisibility] = useState(false);

  const filterdistrictResults = division_id =>
    setDistrict(_district =>
      alldistrict.filter(dist => dist.division_id === division_id),
    );
  const filtercourtResults = district_id =>
    setCourt(_court =>
      allCourt.filter(dist => dist.geo_district_id === district_id),
    );
  const [division_id, setdivisionId] = useState(null);
  const [district_id, setDistrictId] = useState(null);

  const _fetchdivisionData = async () => {
    try {
      let url = `${BASE_URL}/GetDivission`;
      let response = await axios.get(url).then(res => res.data);
      return response;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const _fetchDistrictData = async data => {
    try {
      let dataToSend = {
        division_id: data,
      };
      let formBody = [];
      for (let key in dataToSend) {
        let encodedKey = encodeURIComponent(key);
        let encodedValue = encodeURIComponent(dataToSend[key]);
        formBody.push(encodedKey + '=' + encodedValue);
      }
      formBody = formBody.join('&');
      let url = `${BASE_URL}/DivisionToDistrict`;
      let response = await axios.post(url, formBody).then(res => res.data);
      return response;
    } catch (err) {
      console.log('Error', err);
    }
  };

  const showDatePicker = () => {
    setDatePickerVisibility(true);
  };

  const hideDatePicker = () => {
    setDatePickerVisibility(false);
  };

  const handleConfirm = val => {
    setselectdate(val);
    hideDatePicker();
  };

  const [visible, setVisible] = React.useState(false);
  const onDismiss = React.useCallback(() => {
    setVisible(false);
  }, [setVisible]);
  const [date, setDate] = React.useState();
  const onChangeSingle = React.useCallback(
    params => {
      setVisible(false);
      setDate(params.date);
    },
    [setVisible, setDate],
  );
  const pastDate = new Date(new Date().setDate(new Date().getDate() - 500000));
  const futureDate = new Date(
    new Date().setDate(new Date().getDate() + 500000),
  );

  const locale = 'en-GB';
  const UType = [
    {label: 'Advocate', value: '1'},
    {label: 'Organisation', value: '2'},
  ];
  const updateUType = (handleChange, value) => {
    handleChange(value);
  };

  useEffect(() => {
    if (Platform.OS === 'android') {
      setDevice_id(1);
    }
    if (Platform.OS === 'ios') {
      setDevice_id(2);
    }
    if (Platform.OS === 'web') {
      setDevice_id(3);
    }

    _fetchdivisionData()
      .then(division => {
        setdivision(division);
      })
      .catch(err => console.log(err));
  }, []);

  const getDstrictsdata = data => {
    _fetchDistrictData(data)
      .then(district => {
        setDistrict(district);
      })
      .catch(err => console.log(err));
  };

  const handleRegister = (values, actions) => {
    setIsSubmitting(true);
    const {
      UserName,
      name,
      email,
      phone,
      address,
      user_type,
      password,
      confirmPassword,
      mobile,
      device_id,
      member_id,
      Dob,
      DeviceInformation,
    } = values;

    const userRegisterData = {
      division_id: division_id,
      district_id: district_id,
      mobile,
      username: UserName,
      password,
      name,
      email,
      phone,
      address,
      user_type: user_type ? user_type : 1,
      device_id: DId,
      member_id,
      Dob:
        Platform.OS === 'web'
          ? date !== null
            ? moment(date).format('DD-MM-YYYY')
            : ''
          : select_date !== null
          ? moment(select_date).format('DD-MM-YYYY')
          : '',
      DeviceInformation: DInfo,
    };

    _regitserUser(userRegisterData)
      .then(res => {
        if (res.code == 200) {
          setUser_id(res.user_id);
          alert(res.msg);
        } else {
          alert(res.msg);
        }
      })
      .catch(err => console.log(err))
      .then(() => {
        setIsSubmitting(false);
      });
  };

  const _regitserUser = async data => {
    let url = `${BASE_URL}/CreateUser`;
    let formBody = [];
    for (let key in data) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(data[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }
    formBody = formBody.join('&');

    try {
      const result = await axios.post(url, formBody).then(res => res.data);
      return result;
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Request cancelled');
      } else if (err.response) {
        if (err.response.code === 422)
          showError(serializeErrors(err.response.data));
        else if (err.response.data.code === 401)
          showError(serializeErrors({error: err.response.data.msg}));
        else showError(serializeErrors({error: 'Failed to register'}));
      } else {
        console.log(err);
      }
    }
  };

  const ipAlert = async () => {
    const ip = await Network.getIpAddressAsync();
    alert(ip);
  };

  return (
    <ContainerFluid style={{flex: 1, backgroundColor: '#f5f5f5'}}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{flexGrow: 1, paddingBottom: 30}}
      >
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={{flex: 1}}
        >
          <View style={styles.mainContainer}>
            {/* Header */}
            <View style={styles.header}>
              <Text style={styles.headerTitle}>নিবন্ধন করুন</Text>
              <Text style={styles.headerSubtitle}>
                একাউন্ট তৈরি করতে ফর্মটি পূরণ করুন
              </Text>
            </View>

            {/* Powered By */}
            <View style={styles.poweredByContainer}>
              <Text style={styles.poweredByText}>
                Powered By: Siddique Enterprise
              </Text>
            </View>

            {/* Form Card */}
            <View style={styles.cardContainer}>
              {error && <ErrorMessage>{error}</ErrorMessage>}

              <Formik
                enableReinitialize
                initialValues={{
                  UserName: '',
                  name: '',
                  password: '',
                  email: '',
                  confirmPassword: '',
                  mobile: '',
                  phone: '',
                  address: '',
                  user_type: '',
                  member_id: '',
                }}
                validationSchema={registerSchema}
                onSubmit={(values, actions) => {
                  handleRegister(values, actions);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                }) => (
                  <>
                    {/* Division & District Picker Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>বিভাগ</Text>
                        <View style={styles.pickerWrapper}>
                          <Picker
                            selectedValue={division_id ? division_id : 0}
                            style={styles.picker}
                            onValueChange={itemValue => {
                              setdivisionId(itemValue);
                              getDstrictsdata(itemValue);
                            }}
                            mode="dropdown"
                          >
                            <Picker.Item
                              label="বিভাগ নির্বাচন করুন"
                              value="0"
                            />
                            {division.map((item, index) => (
                              <Picker.Item
                                label={item.division_name_bng}
                                value={item.geo_division_id}
                                key={index}
                              />
                            ))}
                          </Picker>
                        </View>
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>জেলা</Text>
                        <View style={styles.pickerWrapper}>
                          <Picker
                            selectedValue={district_id ? district_id : 0}
                            style={styles.picker}
                            onValueChange={itemValue => {
                              setDistrictId(itemValue);
                            }}
                            mode="dropdown"
                          >
                            <Picker.Item label="জেলা নির্বাচন করুন" value="0" />
                            {district.map((item, index) => (
                              <Picker.Item
                                label={item.district_name_bng}
                                value={item.geo_district_id}
                                key={index}
                              />
                            ))}
                          </Picker>
                        </View>
                      </View>
                    </View>

                    {/* Username & Full Name Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>ইউজারনেম</Text>
                        <Popable
                          style={styles.popableStyleLeft}
                          action="hover"
                          content="Username (Short Name)"
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.UserName}
                            onChangeText={handleChange('UserName')}
                            onBlur={handleBlur('UserName')}
                            placeholder="ইউজারনেম (সংক্ষিপ্ত)"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.UserName && errors.UserName && (
                          <ErrorText>{errors.UserName}</ErrorText>
                        )}
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>পুরো নাম</Text>
                        <Popable
                          style={styles.popableStyleRight}
                          action="hover"
                          content="Full Name"
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.name}
                            onChangeText={handleChange('name')}
                            onBlur={handleBlur('name')}
                            placeholder="পুরো নাম"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.name && errors.name && (
                          <ErrorText>{errors.name}</ErrorText>
                        )}
                      </View>
                    </View>

                    {/* Date of Birth & Member ID Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>জন্ম তারিখ</Text>
                        <Popable
                          style={styles.popableStyleLeft}
                          action="hover"
                          content="Date of birth: DD-MM-YYYY"
                        >
                          <TouchableOpacity
                            onPress={() =>
                              Platform.OS === 'web'
                                ? setVisible(true)
                                : showDatePicker()
                            }
                            style={styles.dateInputWrapper}
                            activeOpacity={0.7}
                          >
                            <TextInput
                              style={styles.dateInput}
                              value={
                                Platform.OS === 'web'
                                  ? date !== null
                                    ? moment(date).format('DD-MM-YYYY')
                                    : ''
                                  : select_date !== null
                                  ? moment(select_date).format('DD-MM-YYYY')
                                  : ''
                              }
                              onChangeText={handleChange('Dob')}
                              onBlur={handleBlur('Dob')}
                              placeholder="DD-MM-YYYY"
                              placeholderTextColor="#999"
                              editable={false}
                            />
                            <Icon
                              name="calendar-today"
                              size={22}
                              color="#307ecc"
                            />
                          </TouchableOpacity>
                        </Popable>
                        {Platform.OS === 'web' ? (
                          <DatePickerModal
                            locale={locale}
                            mode="single"
                            visible={visible}
                            onDismiss={onDismiss}
                            date={date}
                            onConfirm={onChangeSingle}
                            validRange={{
                              startDate: pastDate,
                              disabledDates: [futureDate],
                            }}
                            label="Date of birth"
                          />
                        ) : (
                          <DateTimePickerModal
                            isVisible={isDatePickerVisible}
                            mode="date"
                            onConfirm={handleConfirm}
                            onCancel={hideDatePicker}
                            minimumDate={new Date()}
                          />
                        )}
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>সদস্য আইডি</Text>
                        <Popable
                          style={styles.popableStyleRight}
                          action="hover"
                          content="Advocate Member Id No."
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.member_id}
                            keyboardType="phone-pad"
                            onChangeText={handleChange('member_id')}
                            onBlur={handleBlur('member_id')}
                            placeholder="সদস্য আইডি নম্বর"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.member_id && errors.member_id && (
                          <ErrorText>{errors.member_id}</ErrorText>
                        )}
                      </View>
                    </View>

                    {/* Mobile & Email Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>মোবাইল নম্বর</Text>
                        <Popable
                          style={styles.popableStyleLeft}
                          action="hover"
                          content="Mobile No."
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.mobile}
                            keyboardType="phone-pad"
                            onChangeText={handleChange('mobile')}
                            onBlur={handleBlur('mobile')}
                            placeholder="মোবাইল নম্বর"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.mobile && errors.mobile && (
                          <ErrorText>{errors.mobile}</ErrorText>
                        )}
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>ইমেইল</Text>
                        <Popable
                          style={styles.popableStyleRight}
                          action="hover"
                          content="Email Address"
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.email}
                            keyboardType="email-address"
                            onChangeText={handleChange('email')}
                            onBlur={handleBlur('email')}
                            placeholder="ইমেইল ঠিকানা"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.email && errors.email && (
                          <ErrorText>{errors.email}</ErrorText>
                        )}
                      </View>
                    </View>

                    {/* Alternative Mobile & Address Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>বিকল্প মোবাইল</Text>
                        <Popable
                          style={styles.popableStyleLeft}
                          action="hover"
                          content="Another Mobile No."
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.phone}
                            keyboardType="phone-pad"
                            onChangeText={handleChange('phone')}
                            onBlur={handleBlur('phone')}
                            placeholder="বিকল্প মোবাইল"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.phone && errors.phone && (
                          <ErrorText>{errors.phone}</ErrorText>
                        )}
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>ঠিকানা</Text>
                        <Popable
                          style={styles.popableStyleRight}
                          action="hover"
                          content="Address"
                        >
                          <TextInput
                            style={styles.inputStyle}
                            value={values.address}
                            onChangeText={handleChange('address')}
                            onBlur={handleBlur('address')}
                            placeholder="ঠিকানা"
                            placeholderTextColor="#999"
                          />
                        </Popable>
                        {touched.address && errors.address && (
                          <ErrorText>{errors.address}</ErrorText>
                        )}
                      </View>
                    </View>

                    {/* Password & Confirm Password Row */}
                    <View style={styles.rowContainer}>
                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>পাসওয়ার্ড</Text>
                        <Popable
                          style={styles.popableStyleLeft}
                          action="hover"
                          content="Password"
                        >
                          <View style={styles.passwordWrapper}>
                            <TextInput
                              style={styles.passwordInput}
                              value={values.password}
                              onChangeText={handleChange('password')}
                              onBlur={handleBlur('password')}
                              placeholder="পাসওয়ার্ড"
                              placeholderTextColor="#999"
                              secureTextEntry={true}
                            />
                            <Icon
                              name="lock"
                              size={20}
                              color="#666"
                              style={styles.passwordIcon}
                            />
                          </View>
                        </Popable>
                        {touched.password && errors.password && (
                          <ErrorText>{errors.password}</ErrorText>
                        )}
                      </View>

                      <View style={styles.halfField}>
                        <Text style={styles.labelText}>পাসওয়ার্ড নিশ্চিত</Text>
                        <Popable
                          style={styles.popableStyleRight}
                          action="hover"
                          content="Confirm Password"
                        >
                          <View style={styles.passwordWrapper}>
                            <TextInput
                              style={styles.passwordInput}
                              value={values.confirmPassword}
                              onChangeText={handleChange('confirmPassword')}
                              onBlur={handleBlur('confirmPassword')}
                              placeholder="পাসওয়ার্ড নিশ্চিত"
                              placeholderTextColor="#999"
                              secureTextEntry={true}
                            />
                            <Icon
                              name="lock-outline"
                              size={20}
                              color="#666"
                              style={styles.passwordIcon}
                            />
                          </View>
                        </Popable>
                        {touched.confirmPassword && errors.confirmPassword && (
                          <ErrorText>{errors.confirmPassword}</ErrorText>
                        )}
                      </View>
                    </View>

                    {/* Submit Button */}
                    <View style={styles.buttonContainer}>
                      <TouchableOpacity
                        style={styles.submitButton}
                        onPress={handleSubmit}
                        disabled={isSubmitting}
                        activeOpacity={0.8}
                      >
                        <Text style={styles.submitButtonText}>
                          {isSubmitting ? 'নিবন্ধন হচ্ছে...' : 'নিবন্ধন করুন'}
                        </Text>
                        <Icon name="arrow-forward" size={20} color="#fff" />
                      </TouchableOpacity>
                    </View>
                  </>
                )}
              </Formik>
            </View>

            {/* Login Link */}
            <View style={styles.loginLinkContainer}>
              <Text style={styles.loginLinkText}>
                ইতিমধ্যে একটি একাউন্ট আছে?
              </Text>
              <TouchableOpacity onPress={() => navigation.navigate('Login')}>
                <Text style={styles.loginLink}>লগইন করুন</Text>
              </TouchableOpacity>
            </View>
          </View>
        </KeyboardAvoidingView>
      </ScrollView>
    </ContainerFluid>
  );
}

export default Register;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 13,
    color: '#fff',
    opacity: 0.9,
    marginTop: 2,
  },
  poweredByContainer: {
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  poweredByText: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  cardContainer: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 4,
  },
  rowContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 4,
  },
  halfField: {
    width: '48%',
    marginBottom: 8,
  },
  labelText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    marginBottom: 4,
  },
  inputStyle: {
    height: 44,
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    paddingHorizontal: 12,
    fontSize: 14,
    color: '#333',
    backgroundColor: '#fafafa',
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    backgroundColor: '#fafafa',
    height: 44,
    justifyContent: 'center',
  },
  picker: {
    height: 44,
    color: '#333',
    fontSize: 14,
  },
  dateInputWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    backgroundColor: '#fafafa',
    height: 44,
    paddingHorizontal: 12,
  },
  dateInput: {
    flex: 1,
    height: 44,
    fontSize: 14,
    color: '#333',
  },
  passwordWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#e0e0e0',
    borderRadius: 8,
    backgroundColor: '#fafafa',
    height: 44,
    paddingHorizontal: 12,
  },
  passwordInput: {
    flex: 1,
    height: 44,
    fontSize: 14,
    color: '#333',
  },
  passwordIcon: {
    marginLeft: 8,
  },
  popableStyleLeft: {
    opacity: 0.8,
    width: 'auto',
    marginLeft: -10,
  },
  popableStyleRight: {
    opacity: 0.8,
    width: 'auto',
    marginRight: -10,
  },
  buttonContainer: {
    marginTop: 12,
    marginBottom: 4,
  },
  submitButton: {
    backgroundColor: '#307ecc',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 14,
    borderRadius: 8,
    shadowColor: '#307ecc',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.3,
    shadowRadius: 6,
    elevation: 6,
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 8,
  },
  loginLinkContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 10,
  },
  loginLinkText: {
    fontSize: 14,
    color: '#666',
  },
  loginLink: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#307ecc',
    marginLeft: 6,
  },
  // Responsive
  '@media (max-width: 600px)': {
    halfField: {
      width: '100%',
    },
  },
});
